/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfDocumentsV1DocumentEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_DOCUMENTS_V1_DOCUMENT_EVENT_ENTITY_NAME = 'ixf.documents.v1.DocumentEvent';
export const ixfDocumentsV1DocumentEventEntity = new schema.Entity<IxfDocumentsV1DocumentEvent>(IXF_DOCUMENTS_V1_DOCUMENT_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxfDocumentsV1DocumentEvent) => `${entity.metadata?.eventId}` });

